import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './Tarif.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

const TarifTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId="mod-table-sample"
      title={t.translate('modules.tarif.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Aktif',
          searchable: true,
          key: 'aktif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.aktif)
        },{
          label: 'Berdasarkan Netto',
          searchable: true,
          key: 'berdasarkanNetto',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.berdasarkanNetto)
        },{
          label: 'Jenis Tarif',
          searchable: true,
          key: 'jenisTarif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.jenisTarif)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        },{
          label: 'Kode Objek Pajak ID',
          searchable: true,
          key: 'kodeObjekPajakId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kodeObjekPajakId)
        },{
          label: 'Progresif',
          searchable: true,
          key: 'progresif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.progresif)
        },{
          label: 'Status',
          searchable: true,
          key: 'status',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.status)
        },{
          label: 'Tahun Mulai Berlaku',
          searchable: true,
          key: 'tahunMulaiBerlaku',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunMulaiBerlaku)
        },{
          label: 'Tahun Akhir Berlaku',
          searchable: true,
          key: 'tahunAkhirBerlaku',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tahunAkhirBerlaku)
        },{
          label: 'Tarif DPP',
          searchable: true,
          key: 'tarifDPP',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifDPP)
        },{
          label: 'Tarif Pajak',
          searchable: true,
          key: 'tarifPajak',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifPajak)
        },{
          label: 'Tarif Progresif ID',
          searchable: true,
          key: 'tarifProgresifId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifProgresifId)
        },{
          label: 'Tarif Tambahan',
          searchable: true,
          key: 'tarifTambahan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifTambahan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/tarif/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/tarif/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default TarifTable
